module.exports = __webpack_public_path__ + "static/favicon-6a9097d0c4222b19a7a44363c949f4b4.png";